export default __webpack_public_path__ + "static/media/poi_marker.b8d25ac5.svg";